<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="alert alert-info">{{$t('alerts.loading')}}...</div>
          <div v-if="error" class="alert alert-danger">{{ error }}</div>
        </b-col>
      </b-row>
      <b-row v-if="!isLoading && !error">
        <b-col>
          <b-row v-for="(item, index) in items" v-bind:key="'notAssignedTask-' + index" @mouseover="hoveredRow(index)" @mouseleave="unHoveredRow(index)">
            <b-col cols="12" lg="4">
              <router-link :to="{name: 'EXCMCaseShow', params: { id: item.idCase['@id'] }}">
                <h6>Zgłoszenie #{{ getIdLink(item.idCase['@id']) }}</h6>
              </router-link>
              <p>{{ item.idCase.caseType.title }} | <router-link :to="{name: 'EXCMTaskShow', params: { id: item['@id'] }}">{{ item.idTaskType.title }}</router-link></p>
            </b-col>
            <b-col cols="12" lg="4">
              <div v-if="item.idCase && item.idCase.idDevice">
                <router-link :to="{name: 'EXCMDeviceShow', params: { id: item.idCase.idDevice['@id'] }}" v-if="item.idCase && item.idCase.idDevice && item.idCase.idDevice.idDeviceModel"><b>{{ item.idCase.idDevice.idDeviceModel.model }}</b></router-link>
                <p>{{ item.idCase.idDevice.serialNumber }}</p>
              </div>
            </b-col>
            <b-col cols="12" lg="4">
              <div :ref="'task-' + index">
                <router-link v-if="item.idCase && item.idCase.contractorUserData" :to="{name: 'FirmShow', params: { id: item.idCase.contractorUserData['@id'] }}">
                  <b v-b-tooltip.hover :title="item.idCase.contractorUserData.firmname1">{{ item.idCase.contractorUserData.firmname2 }}</b>
                </router-link>
                <p v-if="item.idCase && item.idCase.contractorUserData">{{ item.idCase.contractorUserData.city }}, {{ item.idCase.contractorUserData.street }}</p>
              </div>
              <div :ref="'taskActions-' + index" style="display: none;">
                <b-btn variant="outline-primary" size="sm" class="float-right m-0" @click="dispatch(item['@id'])">{{ $t('global.assignTask') }}</b-btn>
              </div>
            </b-col>
            <b-col cols="12" v-if="index + 1 !== items.length">
              <hr class="mt-0 mb-3">
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-if="items.length > 0">
        <b-col cols="12">
          <div v-if="view">
<!--            <button-->
<!--              :disabled="!view['hydra:previous']"-->
<!--              type="button"-->
<!--              class="btn btn-basic btn-sm"-->
<!--              @click="getTasks(view['hydra:first'])">{{$t('buttons.firstPage')}}</button>-->
            &nbsp;
            <button
              :disabled="!view['hydra:previous']"
              type="button"
              class="btn btn-basic btn-sm"
              @click="getTasks(view['hydra:previous'])">{{$t('buttons.previousPage')}}</button>
            &nbsp;
            <button
              :disabled="!view['hydra:next']"
              type="button"
              class="btn btn-basic btn-sm"
              @click="getTasks(view['hydra:next']+'title=tytuł')">{{$t('buttons.nextPage')}}</button>
            &nbsp;
<!--            <button-->
<!--              :disabled="!view['hydra:last']"-->
<!--              type="button"-->
<!--              class="btn btn-basic btn-sm"-->
<!--              @click="getTasks(view['hydra:last'])">{{$t('buttons.lastPage')}}</button>-->
            &nbsp;
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <h6 class="text-center">{{ $t('views.dailyPlan.show.noNotAssignedTasks') }}</h6>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import getId from '@/utils/getIdFromLink'

export default {
  name: 'TaskTable',

  props: {
    assigned: {
      type: Boolean,
      default: true
    },
    notAssigned: {
      type: Boolean,
      default: true
    },
    date: {
      type: String,
      default: null
    },
    finished: {
      type: Boolean,
      default: true
    },
    iriServiceman: {
      type: String,
      default: null
    },
    dispatchAction: {
      type: Function,
      default: function () {
        // console.log()
      }
    },
    dailyPlanStatuses: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      view: null,
      pagination: [],
      items: [],
      error: '',
      isLoading: false
    }
  },
  created () {
    this.getTasks()
    this.channelDeliveries = this.$store.state.Pusher.subscribe('e_x_c_m_tasks')
    this.channelDeliveries.bind('e_x_c_m_tasks', data => {
      this.getTasks()
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_c_m_tasks')
  },

  methods: {
    dispatch (taskId) {
      let params = {
        idUserData: parseInt(this.getIdLink(this.iriServiceman)),
        date: this.$moment(this.date).format('YYYY-MM-DD')
      }
      this.$http.put('api/e_x_c_m_tasks/' + this.getIdLink(taskId) + '/dispatch',
        params
      )
        .then(response => {
          this.$Swal({
            type: 'success',
            title: 'Operacja wykonana pomyślnie',
            timer: 2500
          })
          this.dispatchAction()
        })
        .catch(error => {
          if (error.response.status === 400 || error.response.status === 403) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    hoveredRow (index) {
      if (this.dailyPlanStatuses && this.dailyPlanStatuses.confirmed === 0) {
        let ref = this.$refs['task-' + index]
        if (ref.length === 1) {
          ref[0].style.display = 'none'
        }
        ref = this.$refs['taskActions-' + index]
        if (ref.length === 1) {
          ref[0].style.display = ''
        }
      }
    },

    unHoveredRow (index) {
      if (this.dailyPlanStatuses && this.dailyPlanStatuses.confirmed === 0) {
        let ref = this.$refs['task-' + index]
        if (ref.length === 1) {
          ref[0].style.display = ''
        }
        ref = this.$refs['taskActions-' + index]
        if (ref.length === 1) {
          ref[0].style.display = 'none'
        }
      }
    },

    getTasks () {
      let url = 'api/e_x_c_m_tasks?_page=1'
      if (!this.assigned && this.notAssigned) {
        url += '&lastPoolTask.operation=0'
      }
      // if (this.date) {
      //   url += '&startDate=' + this.date
      // }
      if (!this.finished) {
        url += '&finished=0'
      }
      this.$http
        .get(url)
        .then(response => {
          this.$emit('input', response.data['hydra:totalItems'])
          this.view = response.data['hydra:view']
          this.items = response.data['hydra:member']
        })
        .catch(error => {
          console.log(error)
          this.error = error
        })
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
